import { Promise } from "rsvp";

export {
  csrfToken,
  fetchGet,
  metaContent,
  xhrDelete,
  xhrGet,
  xhrGetRaw,
  xhrPatch,
  xhrPost,
  xhrPut,
}

function xhrPost(url, params) {
  return xhrAction("POST", url, params);
}

function xhrPut(url, params) {
  return xhrAction("PUT", url, params);
}

function xhrPatch(url, params) {
  return xhrAction("PATCH", url, params);
}

function xhrDelete(url, params) {
  return xhrAction("DELETE", url, params);
}

function xhrAction(action, url, params) {
  return new Promise(function(resolve, reject) {
    let xhr = new XMLHttpRequest();
    const token = csrfToken();

    xhr.open(action, url);
    xhr.onreadystatechange = function() {
      if (this.readyState == 4 && this.status > 0) {
        let data;
        try {
          data = JSON.parse(this.responseText);
        } catch (e) {
          return reject({ error: e });
        }
        if (this.status >= 200 && this.status < 400) {
          return resolve(data);
        } else {
          if (this.status == 401 && data.error_code == "login") {
            window.location.pathname = "/signin";
          }
          return reject(xhrError(this.status, xhr.statusText, data));
        }
      }
    };

    xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
    if (token) {
      xhr.setRequestHeader("X-CSRF-Token", token);
    }

    const body = JSON.stringify(params);
    // IE 11 sends string "undefined" if body is undefined,
    // causing Rails param parsing to raise an exception
    if (body) {
      xhr.send(body);
    } else {
      xhr.send();
    }
  });
}

function xhrError(status, statusText, data) {
  if (data.error) {
    return new XhrError(status, statusText, { _error: data.error });
  } else if (Array.isArray(data.errors)) {
    return new XhrError(status, statusText, {
      _error: data.errors.join("\n")
    });
  } else if (data.errors) {
    return new XhrError(status, statusText, data.errors);
  } else {
    return new XhrError(status, statusText, { _error: statusText });
  }
}

class XhrError extends Error {
  constructor(status, statusText, errors) {
    super(statusText);
    this.status = status;
    this.statusText = statusText;
    this.errors = errors;
  }
}

function xhrGet(url) {
  return new Promise(function(resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.onreadystatechange = function() {
      if (this.readyState == 4) {
        if (this.status >= 200 && this.status < 400) {
          try {
            const data = JSON.parse(this.responseText);
            resolve(data);
          } catch (err) {
            reject({
              status: this.status,
              error: "Could not get a response.",
              body: this.responseText
            });
          }
        } else if (this.status == 401) {
          window.location.pathname = "/signin";
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      }
    };
    xhr.send();
  });
}

function xhrGetRaw(url) {
  return new Promise(function(resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.onreadystatechange = function() {
      if (this.readyState == 4) {
        if (this.status >= 200 && this.status < 400) {
          resolve(this.responseText);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText,
            responseText: this.responseText
          });
        }
      }
    };
    xhr.send();
  });
}

/**
 * Extracted from request.js
 *
 * https://github.com/rails/request.js/blob/71b96e543e662a0ff40203989c18e4dc93107780/src/fetch_request.js#L90
 */
function csrfToken() {
  return getCookie(metaContent("csrf-param")) || metaContent("csrf-token");
}

/**
 * Extracted from request.js
 *
 * https://github.com/rails/request.js/blob/71b96e543e662a0ff40203989c18e4dc93107780/src/lib/utils.js#L1
 */
function getCookie(name) {
  const cookies = document.cookie ? document.cookie.split("; ") : [];
  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = cookies.find(cookie => cookie.startsWith(prefix));

  if (cookie) {
    const value = cookie.split("=").slice(1).join("=");

    if (value) {
      return decodeURIComponent(value);
    }
  }
}

/**
 * Extracted from request.js
 *
 * https://github.com/rails/request.js/blob/71b96e543e662a0ff40203989c18e4dc93107780/src/lib/utils.js#L28
 */
function metaContent(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element && element.content;
}

function fetchGet(url) {
  return window.fetch(url, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
  });
}

export default {
  post: xhrPost,
  get: xhrGet
};
